import { SaveBase } from "./SaveBase";
import { Matrix } from "../../../maths/Matrix";
export class SaveTranslate {
    constructor() {
        this._mat = new Matrix();
    }
    isSaveMark() { return false; }
    restore(runner) {
        this._mat.copyTo(runner._curMat);
        SaveTranslate.POOL[SaveTranslate.POOL._length++] = this;
    }
    static save(runner) {
        var no = SaveTranslate.POOL;
        var o = no._length > 0 ? no[--no._length] : (new SaveTranslate());
        runner._curMat.copyTo(o._mat);
        var _save = runner._save;
        _save[_save._length++] = o;
    }
}
SaveTranslate.POOL = SaveBase._createArray();
